<div class="itb-divider" [ngClass]="{'vertical':this.isVertical }" >
    <mat-divider [vertical]="isVertical" [class]="className"></mat-divider>
</div>